import React, { FC, useMemo } from 'react';
import { BaseLevels, Icon, IconName, Text, TextVariant } from '@kb-front/ui-kit';
import { IProductData } from 'shared/model';

import SkeletonConditions from './Skeleton';

import './index.scss';

interface IProps {
  productData?: IProductData;
}

const Conditions: FC<IProps> = ({ productData }) => {
  const conditions = useMemo(() => productData?.conditions || [], [productData]);

  const createConditionsList = (list: string[]) => (
    <ul className="conditions__content__list">
      {list?.map((condition: string) => (
        <li className="conditions__content__list__item" key={condition}>
          <Icon iconName={IconName.MINUS} variant={TextVariant.NEGATIVE} />
          <span className="conditions__content__list__item-text">
            <Text level={BaseLevels.L2}>{condition}</Text>
          </span>
        </li>
      ))}
    </ul>
  );

  return <div className="conditions">{productData?.title ? <div>{createConditionsList(conditions)}</div> : <SkeletonConditions />}</div>;
};

export default Conditions;
